import { useThemeColors } from '@codezo/theme';
import { Box } from '@mantine/core';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
	const colors = useThemeColors();

	return (
		<Box
			style={{
				minHeight: '100vh',
				backgroundColor: colors.background,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '16px',
			}}
		>
			<Outlet />
		</Box>
	);
}
